<template>
	<div class="panel_settlement">
		<div style="padding-top:7px;">
			<span class="priceItem">
				<span class="label">总计：</span>
				<span class="price">￥{{money}}</span>
			</span>
			<span class="priceItem">
				<span class="label">优惠金额：</span>
				<span class="price">￥0</span>
			</span>
		</div>
		<div>
			<span class="priceItem" style="margin-right: 20px;">
				<span class="label">应付金额：</span>
				<span class="price" style="color:#FF2F2F;">￥{{money}}</span>
			</span>
			<el-button style="width:80px;" type="warning" size="small" plain @click="openBeizhu">备注</el-button>
			<el-button style="width:100px;" type="warning" size="small" plain @click="submitOrder">生成订单</el-button>
			<el-button style="width:80px;" type="warning" size="small" @click="submitOrderAndSettlement">结算</el-button>
		</div>
		<!-- 备注弹窗 -->
		<div v-if="drawerRemark_state">
			<drawerRemark :type="'ymqc'" @submit="submit_drawerRemark"></drawerRemark>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlement_state">
			<dialogSettlement :type="'order'" :orderId="curOrder._id" @submit="submit_dialogSettlement"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import drawerRemark from "../drawer/remark.vue"
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	export default {
		components:{drawerRemark,dialogSettlement},
		data(){
			return{
				// 备注
				drawerRemark_state:false,
				// 结算
				dialogSettlement_state:false,
				curOrder:{},
				// 
				o:null,
				serviceList:[],
				// 是否直接结算
				direct:false,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
			detail(){
				return this.$store.state.ymqc.detail;
			},
			addParams(){
				return this.$store.state.ymqc.addParams;
			},
			money(){
				return this.$store.state.ymqc.money;
			},
			activityMoney(){
				return this.$store.state.ymqc.activityMoney;
			},
			remark(){
				return this.$store.state.ymqc.remark;
			},
		},
		mounted(){
			
		},
		methods:{
			submitOrderAndSettlement(){
				this.direct = true;
				this.submitOrder();
			},
			// 创建订单
			submitOrder(){
				console.log(this.curPetInfo)
				if(!this.addParams.saleManIdList){
					this.$message({
						message: '请选择销售人员',
						type: 'error'
					});
					return ;
				}
				let salesMans = []
				for(let i=0;i<this.addParams.saleManIdList.length;i++){
					let arr = this.addParams.saleManIdList[i].split(',')
					salesMans.push({"userId": arr[0],"userName": arr[1]})
				}
				if(this.detail.list.length===0){
					// if(this.detail.type===1&&this.detail.buyWay==='2'){
					// 	let total = 0;
					// 	for(let i=0;i<this.detail.list.length;i++){
					// 		total = this.$public.jia(total,this.detail.list[i].planMoney)
					// 	}
					// 	if(total<this.addParams.servicePackage.min_price){
					// 		this.$message({
					// 			message: '自定义金额不能小于'+this.addParams.servicePackage.min_price,
					// 			type: 'error'
					// 		});
					// 		return ;
					// 	}
					// 	if(total>this.addParams.servicePackage.max_price){
					// 		this.$message({
					// 			message: '自定义金额不能大于'+this.addParams.servicePackage.max_price,
					// 			type: 'error'
					// 		});
					// 		return ;
					// 	}
					// }
					this.$message({
						// message: '请选择药品',
						message: '记录生成失败！！请查看药品、价格是否正确',
						type: 'error'
					});
					return ;
				}
				let params = {
					"memberId": this.userInfo._id,
					"memberName": this.userInfo.basic_info.nick_name,
					"memberMobile": this.userInfo.basic_info.user_mobile,
					"petId": this.curPetInfo._id,
					"petName": this.curPetInfo.nick_name,
					"petType": this.curPetInfo.apply_type.title,
					"typeName": this.curPetInfo.category_info.name, // Desc:宠物种类 Nullable:False
					"sex": this.curPetInfo.pet_sex,
					"birthDay": this.curPetInfo.bron_date,
					"weight": this.addParams.newestWeight,
					"serviceTypeId": this.addParams.type==='QC'?2:1,  // 1疫苗；2驱虫
					"payType": 1,  // 1全额支付；2计划支付;
					"discountRate": 0,  // 优惠折扣率 默认为0
					"remark": this.remark,
					planList:this.detail.list,
					salesMans:salesMans,
					servicePackageName:this.addParams.servicePackage.title,
					servicePackageId:this.addParams.servicePackage.groupId,
				}
				console.log(params)
				let loading = this.$loading();
				this.$http.post('/api/MedicalPackage/Insert',params).then(res=>{
					loading.close();
					if (res.code == 0){
						if(this.direct){
							this.curOrder = res.data.data;
							this.dialogSettlement_state = true;
						}else{
							this.$message({
								message: '操作成功',
								type:'success'
							});
							this.$store.commit('ymqc/set_type','list')
						}
					}
				})
			},
			// 结算
			submit_dialogSettlement(a){
				this.dialogSettlement_state = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.$store.dispatch("mendian/getUserInfo",this.userInfo._id)
				}
				this.$store.commit('ymqc/set_type','list')
			},
			// 备注
			openBeizhu(){
				this.drawerRemark_state=true;
			},
			submit_drawerRemark(){
				this.drawerRemark_state=false;
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_settlement{
	display: flex;
	justify-content: space-between;
	padding:10px 20px;
	background-color: #fff;
	box-shadow: 0 -3px 3px 0px #f5f5f5;
	.priceItem{
		display: inline-flex;align-items: center;
		margin-right: 40px;
		.label{
			font-size: 14px;color:$fontColor;
		}
		.price{
			font-size: 20px;color:$fontColor;
		}
	}
}
</style>
